<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <label class="title">中心总览</label>
            注册时间：<a-range-picker v-model="registerDateRange" value-format="YYYY-MM-DD" @change="dateChange"
                                 :ranges="{ '本日': [moment(), moment()], '本周': [moment().startOf('week'), moment().endOf('week')],'本月': [moment().startOf('month'), moment().endOf('month')]  }"
                      />
          </a-col>

          <!--<a-col :md="6" :sm="8">-->
          <!--<span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">-->
          <!--<a-button type="primary" @click="searchQuery" icon="search">查询</a-button>-->
          <!--<a-button type="" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
          <!--<a @click="handleToggleSearch" style="margin-left: 8px">-->
          <!--{{ toggleSearchStatus ? '收起' : '展开' }}-->
          <!--<a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
          <!--</a>-->
          <!--</span>-->
          <!--</a-col>-->

        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div style="margin-top: 10px">
      <a-table
        ref="table"

        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a v-if="record.centerid" @click="handleInfoView(record)">成员明细</a>
        </span>
        <span slot="failtype1" style="color: green">
          不符合纳入标准
        </span>
        <span slot="failtype2" style="color: green">
          符合排除标准
        </span>
        <span slot="failtype3" style="color: green">
          拒绝参与项目
        </span>
        <span slot="failtype4" style="color: green">
          其他原因
        </span>
        <span slot="filtratefailtotal" style="color: red">
          （终止筛选总人数）
        </span>
        <span slot="resrate">
          基线应答率
          <a-tooltip class="info-row" >
              <template slot="title">
                基线应答率=基线提交人数/注册人数-筛选期的人数-终止筛选的人数中（符合排除，不符合纳入，去重后的人数）
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
        </span>
      </a-table>
    </div>

  </a-card>
</template>

<script>
  import moment from 'moment';
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'

  import Vue from 'vue'
  export default {
    name: "Center",
    mixins: [JeecgListMixin],
    components: {

    },
    data() {
      return {
        registerDateRange:[],
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        description: '这是用户管理页面',
        queryParam: {},
        centerName:'',
        columns: [
          {
            title: '研究中心',
            align: "center",
            dataIndex: 'centername',
            width: 120,
          },
          {
            title: '新增注册人数',
            align: "center",
            width: 100,
            dataIndex: 'register',
          },
          {
            title: '未筛选人数',
            align: "center",
            width: 120,
            dataIndex: 'nofiltrate',
          },
          // {
          //   title: '通过筛选',
          //   align: "center",
          //   children:[
          //     {
          //       title: '通过筛选人数',
          //       align: "center",
          //       width: 120,
          //       dataIndex: 'isfiltrate',
          //     },
          //   ],
          // },
          {
            title: '通过筛选人数',
            align: "center",
            width: 120,
            dataIndex: 'isfiltrate',
          },
          {
            title: '未应答人数',
            align: "center",
            width: 120,
            dataIndex: 'noreplay',
          },
          {
            title: '终止筛选',
            children:[

              {
                // title: '不符合纳入标准',
                align: "center",
                width: 120,
                dataIndex: 'failtype1',
                slots: { title: 'failtype1' },
              },
              {
                // title: '符合排除标准',
                align: "center",
                width: 120,
                dataIndex: 'failtype2',
                slots: { title: 'failtype2' },
              },
              {
                // title: '拒绝参与项目',
                align: "center",
                width: 120,
                dataIndex: 'failtype3',
                slots: { title: 'failtype3' },
              },
              {
                // title: '其他原因',
                align: "center",
                width: 120,
                dataIndex: 'failtype4',
                slots: { title: 'failtype4' },
              },
              // {
              //   // title: '终止筛选总人数',
              //   align: "center",
              //   width: 120,
              //   dataIndex: 'filtratefail',
              //   slots: { title: 'filtratefail' },
              // },
              {
                // title: '终止筛选总人数',
                align: "center",
                width: 120,
                dataIndex: "filtratefailtotal",
                slots: { title: 'filtratefailtotal' },
              },
            ],
          },
          {
            // title: '应答率',
            align: "center",
            width: 100,
            dataIndex: 'resrate',
            slots: { title: 'resrate' },
            customRender: ((text) => {
              return text+'%'
            })
          },
          {
            title: '操作',
            align: "center",
            width: 100,
            scopedSlots: {customRender: 'action'},
          },
        ],
        url: {
          list: "/project/statistic/register/center",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      // getAction('/project/projectGroup/list',{projectId:this.projectId}).then(res=>{
      //   if(res.success){
      //     res.result.forEach(group=>{
      //       this.columns.forEach(item=>{
      //         if(item.title ==='通过筛选'){
      //           item.children.push({
      //             title: group.name,
      //             align: "center",
      //             width: 120,
      //             dataIndex: 'groupId'+group.id,
      //             customRender: ((text) => {
      //               return text || 0
      //             })
      //           })
      //           this.$set(item,'children',item.children)
      //         }
      //       })
      //     })
      //   }
      // })
      this.queryParam.projectId = this.projectId
      this.loadData()

    },
    methods: {
      moment,
      dateChange(){
        if(this.registerDateRange.length===0){
          this.queryParam.startDate = ''
          this.queryParam.endDate = ''
        }else {
          this.queryParam.startDate = this.registerDateRange[0]
          this.queryParam.endDate = this.registerDateRange[1]
        }
        this.loadData()
      },
      handleInfoView(record){
        this.$emit('change',record.centerid)
      }
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>
